import { render, staticRenderFns } from "./DetalhesVisita.vue?vue&type=template&id=b5123d16&scoped=true"
import script from "./DetalhesVisita.vue?vue&type=script&lang=js"
export * from "./DetalhesVisita.vue?vue&type=script&lang=js"
import style0 from "./DetalhesVisita.vue?vue&type=style&index=0&id=b5123d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5123d16",
  null
  
)

export default component.exports